var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-view",on:{"mousemove":_vm.enableSpeaking}},[_c('FuseaccessLogo',{staticClass:"fuseaccess-logo"}),_c('InteractiveHead',{staticClass:"interactive-head",attrs:{"colorMode":_vm.colorMode}}),_c('h1',[_vm._v(_vm._s(_vm.command))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }